import GeneralTracker from '../GeneralTracker';


export default class UserInfoTracker extends GeneralTracker {
  CAPTURE_NAME = 'session:user:info';
  DATALAYER = true;
  VERSION = '1';

  constructor() {
    super();

    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  }

  setHandlers() {
    const service = this.getService();
    service.on('setUserInfo', this.onSetUserInfo);
  }

  onSetUserInfo = (payload) => {
    const info = { userCountry: payload.realCountry };

    this.track(info);
  };
}
